import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { getPadding, PADDING_SCHEMA } from '../padding';
export const ImagePropsSchema = z.object({
    style: z
        .object({
        padding: PADDING_SCHEMA,
        backgroundColor: COLOR_SCHEMA,
        textAlign: z.enum(['center', 'left', 'right']).optional().nullable(),
    })
        .optional()
        .nullable(),
    props: z
        .object({
        width: z.number().optional().nullable(),
        height: z.number().optional().nullable(),
        url: z.string().optional().nullable(),
        alt: z.string().optional().nullable(),
        linkHref: z.string().optional().nullable(),
        contentAlignment: z.enum(['top', 'middle', 'bottom']).optional().nullable(),
    })
        .optional()
        .nullable(),
});
export function Image({ style, props }) {
    var _e, _t, _y, _10, _11, _12, _13, _14;
    const sectionStyle = {
        padding: getPadding(style === null || style === void 0 ? void 0 : style.padding),
        backgroundColor: (_e = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _e !== void 0 ? _e : undefined,
        textAlign: (_t = style === null || style === void 0 ? void 0 : style.textAlign) !== null && _t !== void 0 ? _t : undefined,
    };
    const linkHref = (_y = props === null || props === void 0 ? void 0 : props.linkHref) !== null && _y !== void 0 ? _y : null;
    const width = (_10 = props === null || props === void 0 ? void 0 : props.width) !== null && _10 !== void 0 ? _10 : undefined;
    const height = (_11 = props === null || props === void 0 ? void 0 : props.height) !== null && _11 !== void 0 ? _11 : undefined;
    const imageElement = (React.createElement("img", { alt: (_12 = props === null || props === void 0 ? void 0 : props.alt) !== null && _12 !== void 0 ? _12 : '', src: (_13 = props === null || props === void 0 ? void 0 : props.url) !== null && _13 !== void 0 ? _13 : '', width: width, height: height, style: {
            width,
            height,
            outline: 'none',
            border: 'none',
            textDecoration: 'none',
            verticalAlign: (_14 = props === null || props === void 0 ? void 0 : props.contentAlignment) !== null && _14 !== void 0 ? _14 : 'middle',
            display: 'inline-block',
            maxWidth: '100%',
        } }));
    if (!linkHref) {
        return React.createElement("div", { style: sectionStyle }, imageElement);
    }
    return (React.createElement("div", { style: sectionStyle },
        React.createElement("a", { href: linkHref, style: { textDecoration: 'none' }, target: "_blank" }, imageElement)));
}
//# sourceMappingURL=Image.js.map